import { FoldersPageHeaderQuery } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import DocumentsResourceHeader from 'modules/documents/components/DocumentsResourceHeader'
import { getTitle } from 'modules/documents/lib/Folders'

export type Folder = FoldersPageHeaderQuery['documents']['ancestors']['edges'][number]['node']
export type Employee = FoldersPageHeaderQuery['employees']['employee']

interface Props {
  employee: Employee
  folder: Folder
}

const FoldersPageHeader = ({ employee, folder }: Props) => {
  const { navigation } = useNavigation()

  const preferredName = employee?.preferredName || employee?.firstName

  const title = i18n.tCurrent('documents.user_type', false, {
    documentType: getTitle(folder?.name),
    user: preferredName
  })

  const employeeFolder = employee?.folders.find((f) => f.folderId === folder.id)
  const canUploadDocument = !!employeeFolder?._policies?.edit?.can

  const url = employee
    ? navigation.employees.id.documents.folderId.new.fullPath({
        id: employee.id,
        folderId: folder.id
      })
    : undefined

  return <DocumentsResourceHeader title={title} canUploadDocument={canUploadDocument} url={url} />
}

export default FoldersPageHeader
